// extracted by mini-css-extract-plugin
export default {"contentLeft":"stickyComponent_contentLeft__Ucr2g","border":"stickyComponent_border__XgLvE","period":"stickyComponent_period__cAbwy"};